import { render, staticRenderFns } from "./eduContinueRegisterForm.vue?vue&type=template&id=26200590&"
import script from "./eduContinueRegisterForm.vue?vue&type=script&lang=js&"
export * from "./eduContinueRegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./eduContinueRegisterForm.vue?vue&type=style&index=0&id=26200590&prod&lang=less&"
import style1 from "./eduContinueRegisterForm.vue?vue&type=style&index=1&id=26200590&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports